import React from 'react';
import { StationInfoData, TrainDetailsData } from '../types';

interface StationInfoContext extends StationInfoData {
  onTrainClicked: (TrainDetails: TrainDetailsData, isMobile: boolean) => void;
}

// https://github.com/typescript-cheatsheets/react-typescript-cheatsheet#context
const StationInfoContext = React.createContext({} as StationInfoContext);

export default StationInfoContext;
